import { IdentityUserAri } from '@atlassian/ari';
import type { JiraFilters } from '@atlassian/search-client';

import { type QueryParams } from '../../../common/types';
import type { GenerateSearchUrlType } from '../../../common/ui/app-context';

export const buildJql = ({
	query,
	accountARIs,
}: {
	query: string;
	/*projectARIs: string[];*/
	accountARIs: string[];
}) => {
	const text = query ? `text ~ "${encodeURIComponent(query)}"` : undefined;
	/*const projectJQL =
		projectIds.length > 0 ? `project IN (${encodeURIComponent(projectIds.join(','))})` : undefined;*/
	const accountIds = accountARIs.map(getAccountIdFromUserAri).filter(Boolean);
	const assigneeClause =
		accountIds.length > 0 ? `assignee IN (${encodeURIComponent(accountIds.join(','))})` : undefined;
	return [text, /*projectJQL,*/ assigneeClause].filter(Boolean).join(' AND ');
};

function getAccountIdFromUserAri(userAri?: string): string | undefined {
	try {
		return userAri ? IdentityUserAri.parse(userAri).userId : undefined;
	} catch (e) {
		return undefined;
	}
}

export const getWorkItemPageUrl = ({
	query,
	jiraFilters,
	generateSearchUrl,
	queryParams = {},
}: {
	query: string;
	jiraFilters: JiraFilters;
	generateSearchUrl: GenerateSearchUrlType;
	queryParams?: QueryParams;
}) => {
	const trimmedQuery = query.trim();
	let jql;
	if (
		trimmedQuery !== '' &&
		/*projectARIs.length !== 0 ||*/ jiraFilters.issueFilter.assigneeARIs.length !== 0
	) {
		/* If query is empty we don't need to build jql as it will be ignored by generateSearchUrl
		 ** Otherwise, we pass the JQL to be redirected to work items page */
		jql = buildJql({
			query: trimmedQuery,
			accountARIs: jiraFilters.issueFilter.assigneeARIs,
			/*projectARIs: jiraFilters.issueFilter.projectARIs,*/
		});
	}

	/* generateSearchUrl takes care of navigating to a signle work item page in case the query is a work item key
	 ** Otherwise, it'll take the user to work items page.
	 * */
	return generateSearchUrl(
		{
			...queryParams,
			text: query,
			...(jql && { jql }),
		},
		true,
	);
};
